$(document).ready(function(){
const clientHeight = document.documentElement.clientHeight;

/* nav */
let section;
let navArr = [];
let sectionsArr = [];
let navItems = document.querySelectorAll('.megamenu__nav .megamenu__nav-link');
navItems.forEach(navItemsEl => {
  navArr.push(navItemsEl);
  if(document.querySelector(navItemsEl.getAttribute('href').substr(1))) {
    sectionsArr.push(document.querySelector(navItemsEl.getAttribute('href').substr(1)));
  };
  // console.log(document.querySelector(navItemsEl.getAttribute('href').substr(1)));
  navItemsEl.addEventListener('click', (e) => {
    if(Boolean(sectionsArr.length) && navItemsEl.getAttribute('href').includes('#')) {
      e.preventDefault();
    }
    if(document.body.style) {
      document.body.style = null;
      document.querySelector('.megamenu').classList.remove('megamenu__active');
      document.querySelector('.megamenu__header').classList.remove('megamenu__active');
      document.querySelector('.centerlayer').classList.remove('fixed');
    }
    navArr.forEach(navArrEl => {
      if(navArrEl == e.target) {
        navArrEl.classList.add('active');
      } else {
        navArrEl.classList.remove('active');
      }
    });
    section = document.querySelector(e.target.getAttribute('href').substr(1));
    window.scrollBy({
      top: section.getBoundingClientRect().top - 90,
      // - document.querySelector('.header').scrollHeight,
      left: 0,
      behavior: 'smooth'
    });
    /*
    console.log(section,section.getBoundingClientRect().top);
    document.querySelector(e.target.getAttribute('href').substr(1)).scrollIntoView({
        behavior: 'smooth'
    });
    */
  });
});

const scrollspy = () => {
  switch(Boolean(sectionsArr.length)) {
    case true:
      sectionsArr.forEach(sectionsArrEl => {
        if (clientHeight - sectionsArrEl.getBoundingClientRect().top >= 3*clientHeight/4 && clientHeight - sectionsArrEl.getBoundingClientRect().top <= 2*clientHeight) {
          document.querySelector(`[href*="${sectionsArrEl.getAttribute('id')}"]`).classList.add('active');
          document.querySelector(`.megamenu__nav-link[href*="${sectionsArrEl.getAttribute('id')}"]`).classList.add('megamenu__item-active');
        } else {
          document.querySelector(`[href*="${sectionsArrEl.getAttribute('id')}"]`).classList.remove('active');
          document.querySelector(`.megamenu__nav-link[href*="${sectionsArrEl.getAttribute('id')}"]`).classList.remove('megamenu__item-active');
        }
      });
      break;
  }
}
window.addEventListener('scroll', scrollspy);
});